export const environment = {
  production: true
};

export const APPLICATION_INSIGHTS_CONNECTION_STRING = 'InstrumentationKey=d526c307-992e-4b3a-950d-f91df61112b3;IngestionEndpoint=https://eastus-5.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/';

export const GOOGLE_ANALYTICS_MEASUREMENT_ID = 'G-F088M9H8MH';